import store from '@/store'
import storage from '@octadesk-tech/storage'

export const getParameterHeaders = withUser => {
  if (store && store.getters) {
    const { company, user, token } = store.getters

    const headers = {
      'Content-Type': 'application/json',
      AppSubdomain: company,
      ...(token && { authorization: `Bearer ${token}` })
    }

    if (withUser && user && user.id) {
      headers.userLogged = storage._encrypt(user)
    }

    return headers
  } else return undefined
}
